export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const ACCESS_TOKEN = "accessToken";
export const USER_STORAGE = "userStorage";
export const ROLE_USER = "USER";
export const ROLE_ADMIN = "ADMIN";
export const ROLE_USER_ADMIN = "USER_ADMIN";
export const NOT_FOND = "NOT_FOND";
export const ROLE_ADMIN_CUSTOMER = "ADMIN_CUSTOMER";
export const BRANCH_STORAGE = "branchStorage";

export const AUTH = "AUTH";

export const API_BASE_URL = BASE_URL + "/api";
export const FONT = '"Montserrat", sans-serif';

export function isAdmin() {
  const localStorageItem = localStorage.getItem(USER_STORAGE);
  if (localStorageItem != null) {
    const { role } = JSON.parse(localStorageItem);

    return role == ROLE_ADMIN || role == ROLE_USER_ADMIN;
  }
  return false;
}

export function isEspotive() {
  const localStorageItem = localStorage.getItem(BRANCH_STORAGE);
  if (localStorageItem != null) {
    const { type } = JSON.parse(localStorageItem);

    return type == "ESPORTIVO";
  }
  return true;
}

export function isBoot() {
  const localStorageItem = localStorage.getItem(USER_STORAGE);
  if (localStorageItem != null) {
    const { isBoot } = JSON.parse(localStorageItem);

    return isBoot == "true";
  } else {
    return false;
  }
}

export function getUserLogged() {
  const localStorageItem = localStorage.getItem(USER_STORAGE);
  if (localStorageItem != null) {
    const user = JSON.parse(localStorageItem);

    return user;
  } else {
    return null;
  }
}

export function hasPhotocell() {
  const localStorageItem = localStorage.getItem(BRANCH_STORAGE);
  if (localStorageItem != null) {
    const { hasPhotocell } = JSON.parse(localStorageItem);

    return hasPhotocell == true;
  }
  return false;
}
